const messages = {
  title: "Marketinški pristanci",
  required: "Obavezno",
  answered: "✓ Odgovoreno",
  read: "Pročitano",
  notRead: "Nije pročitano",
  alreadyAnswered: "Već odgovoreno",
  requiredQuestionsMustBeAccepted:
    "Potrebno je prihvatiti još {count} obaveznih pitanja",
  pleaseAnswerQuestions: "Molimo odgovorite na sljedeća pitanja:",
  iAccept: "Prihvatam",
  scrollToUnlock: "Za otključavanje pomjerite se do kraja",
  fieldRequired: "Ovo polje je obavezno",
  scrollToContinue: "↓ Za nastavak pomjerite se do kraja",
  saving: "Spremanje...",
  saveConsents: "Sačuvaj pristanke",
  allRequiredAccepted: "✓ Sva obavezna pitanja prihvaćena",
  requiredConsentsCompleted:
    "{completed}/{total} obaveznih pristanaka popunjeno",
  selectConsentToView:
    "Odaberite pristanak sa liste za prikaz sadržaja",
  readAllContentFirst: "Prvo pročitajte cijeli sadržaj: {names}",
  acceptAllRequiredIn:
    "Prihvatite sva obavezna pitanja u: {names}",
  acceptAllBeforeSaving:
    "Prije čuvanja prihvatite sva obavezna pitanja.",
  failedToSave: "Pristanci nisu sačuvani. Pokušajte ponovo.",
  errorSaving:
    "Došlo je do greške pri čuvanju pristanaka. Pokušajte ponovo.",
  failedToLoad: "Pristanci nisu učitani. Osvježite stranicu.",
  viewPdf: "Pogledaj PDF",
  requiredConsentTitle: "Obavezni pristanak",
  acceptAndContinue: "Prihvati i nastavi",
};

export default {
  messages,
};
